export default __webpack_public_path__ + "assets/images/2d270dd7d282cf10ef02d897ac9dd9b5.svg";